// extracted by mini-css-extract-plugin
export default {"container":"container___dyWdK"};